/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Snackbar, SnackbarContent } from '@mui/material';
import { SnackbarOrigin } from '@mui/material/Snackbar';
import * as React from 'react';

interface ErrorProps {
    errorMessage: string,
    isopen: boolean,
    location?: SnackbarOrigin,
    shouldAutoHide?: boolean
}
class Error extends React.Component<ErrorProps, { open: boolean }> {
    state = {
        open: false
    };
    handleClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    };
    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.errorMessage !== this.props.errorMessage || prevProps.isopen !== this.props.isopen) {
            this.setState({ open: this.props.isopen });
        }
    }

    componentDidMount() {
        this.setState({ open: this.props.isopen });
    }

    render() {
        const anchor = this.props.location === undefined ? {
            horizontal: 'left' as const,
            vertical: 'bottom' as const
        } : this.props.location
        return (
            <Snackbar
                anchorOrigin={anchor}
                open={this.state.open}
                autoHideDuration={this.props.shouldAutoHide === undefined ? 5000 : undefined}
                onClose={this.handleClose}
                style={{ zIndex: 1400 }}
            >
                <SnackbarContent
                    message={this.props.errorMessage}
                />
            </Snackbar>
        );
    }
}

export default Error;
